import React, {useContext, useMemo} from 'react';

import {
  Image,
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  KeyboardAvoidingView,
  Platform,
  TouchableOpacity,
} from 'react-native';
import {useTranslation} from 'react-i18next';

import {ThemeContext} from '../contexts/ThemeContext';
import openLink from '../utils/openLink';
import Api from '../constants/Api';

const RoomNotFoundScreen = () => {
  const {t} = useTranslation();
  const theme = useContext(ThemeContext);
  const styles = useMemo(() => getStyles(theme), [theme]);

  return (
    <SafeAreaView style={styles.container}>
      <KeyboardAvoidingView style={{flex: 1}} behavior={Platform.OS === 'ios' ? 'padding' : null}>
        <View style={{flex: 1, justifyContent: 'center'}}>
          <View style={styles.textContainer}>
            <View style={styles.logoContainer}>
              <TouchableOpacity onPress={() => openLink(Api.webBaseUrl)}>
                <Image
                  source={require('../assets/icon.png')}
                  style={styles.logo}
                />
              </TouchableOpacity>
            </View>

            <Text style={styles.title}>
              {t('RoomNotFoundScreen.message', 'Invalid room')}
            </Text>
          </View>
        </View>
      </KeyboardAvoidingView>
    </SafeAreaView>
  );
};

const getStyles = theme => StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.backgroundPrimary,
  },
  textContainer: {
    alignItems: 'center',
    marginTop: 10,
    marginBottom: 10,
  },
  logoContainer: {
    marginTop: 50,
    marginBottom: 20,
    padding: 10,
    borderRadius: 60,
  },
  logo: {
    width: 80,
    height: 80,
    resizeMode: 'contain',
    borderRadius: 20,
  },
  title: {
    fontSize: 22,
    fontWeight: 'bold',
    color: theme.textPrimary,
  },
});

export default RoomNotFoundScreen;
